import { useState } from "react";
import { Grid } from "@mui/material";
import { Helmet } from "react-helmet-async";
import FormDoctorsDirectory from "../components/FormDoctorsDirectory";
import InsuranceCompanies from "../components/InsuranceCompanies";
import CarouselDoctors from "../components/CarouselDoctors";
import AwardsCertifications from "../01-Services/AwardsCertifications";

const MedicalDirectory = () => {
  const [searchResultsDoctors, setSearchResultsDoctors] = useState([]);

  const handleDoctorSearch = (result) => {
    if (Array.isArray(result)) {
      setSearchResultsDoctors(result);
    } else if (result) {
      setSearchResultsDoctors([result]);
    } else {
      setSearchResultsDoctors([]);
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Directorio médico | Especialistas en Texcoco | Centro Médico MEDAM
        </title>
        <meta
          name="description"
          content="Busca médicos especialistas en Centro Médico MEDAM. Consulta especialidades, horarios y profesionales de la salud disponibles para atención médica en Texcoco."
        />
        <meta
          name="keywords"
          content="directorio médico, especialistas MEDAM, médicos en Texcoco, consulta médica, doctores especialistas, Centro Médico MEDAM"
        />
        <meta name="author" content="Centro Médico MEDAM" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="Centro Médico MEDAM" />
        <meta
          property="og:title"
          content="Directorio médico | Centro Médico MEDAM"
        />
        <meta
          property="og:description"
          content="Encuentra especialistas médicos y agenda una consulta en Centro Médico MEDAM."
        />
        <meta
          property="og:url"
          content="https://centromedicomedam.com/directorioMedico"
        />
        <meta
          property="og:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Directorio médico | Centro Médico MEDAM"
        />
        <meta
          name="twitter:description"
          content="Encuentra especialistas y consulta médica en la red del Centro Médico MEDAM."
        />
        <meta
          name="twitter:image"
          content="https://centromedicomedam.com/IMG/centromedicoMEDAM/fachada_principal_del_centro-medico_MEDAM.png"
        />
        <link
          rel="canonical"
          href="https://centromedicomedam.com/directorioMedico"
        />
      </Helmet>
      <Grid container sx={design.BackGroud}>
        <Grid size={design.grid0} />
        <Grid size={design.grid8}>
          <FormDoctorsDirectory
            onSearch={handleDoctorSearch}
            showDropdown={false}
            enableSearch={true}
          />
        </Grid>
        <Grid size={design.grid0} />
      </Grid>
      <Grid container sx={design.Container}>
        <CarouselDoctors colorIcon="#000" cards={searchResultsDoctors} />
      </Grid>
      <InsuranceCompanies />
      <AwardsCertifications />
    </>
  );
};

export default MedicalDirectory;

const design = {
  BackGroud: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/Fachadade_hospital_MEDAM_night.png)`,
    backgroundPosition: "center 35%",
    height: {
      xs: "400px",
      sm: "400px",
      md: "400px",
      lg: "500px",
    },
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "column",
    pb: { xs: 3, sm: 4, md: 5, lg: 5 },
  },
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: { xs: 30, sm: 36, md: 50, lg: 50 },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "3%",
  },
  grid8: { xs: 11, sm: 7, md: 7, lg: 7 },
  grid0: { xs: 0.5, sm: 0, md: 0, lg: 0 },
  Container: {
    display: "flex",
    justifyContent: "center",
  },
};
